var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisa = function SvgVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 120 80"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 80,
    fill: "#1434CB",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m86.667 44.938 3.657-9.876 2.057 9.876zm14.285 7.9-5.143-25.675h-7.07c-2.386 0-2.967 1.913-2.967 1.913L76.19 52.837h6.697l1.34-3.813h8.168l.753 3.813zM77.187 33.571l.908-5.327s-2.805-1.081-5.73-1.081c-3.162 0-10.67 1.4-10.67 8.21 0 6.41 8.812 6.49 8.812 9.854s-7.904 2.763-10.512.64l-.947 5.57s2.844 1.4 7.192 1.4c4.347 0 10.907-2.283 10.907-8.492 0-6.449-8.892-7.049-8.892-9.853s6.205-2.444 8.932-.92M54.652 52.838h-7.033l4.395-25.675h7.034zM42.311 27.163l-6.39 17.658-.755-3.802h.001l-2.256-11.544s-.272-2.312-3.179-2.312H19.171l-.123.434s3.23.67 7.009 2.936l5.822 22.304h6.983l10.662-25.675z",
    clipRule: "evenodd"
  })));
};
export default SvgVisa;